module.exports = __webpack_public_path__ + "static/img/hotel_back.a6c4eb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/hotel_back.jpg?20181011
// module id = SCDD
// module chunks = 1